import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_graph_interaction } from '../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { ENUM__field_store_interaction } from '../../_fields/_base/_enums/ENUM__field_store_interaction';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { FIELD__image_crop_box } from '../../_fields/image/FIELD__image_crop_box';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__field_role } from '../_base/ENUM__field_role';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_IMAGE__viewport extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static = ENUM__dto_class_name.INVOCATION_IMAGE__VIEWPORT;

  /*
   *
   */

  static CREATE_VIEWPORT_FOR(graph: DTO_GRAPH__instance, field: FIELD__image_asset) {
    let out = super.create_node_for(graph);
    assert_instanceof(out, INVOCATION_IMAGE__viewport);

    out.set_category(field.category);

    graph.edge__try_add_for_fields(out.out__image_cropped, field);

    return out;
  }

  /*
   * FIELDS
   */

  @FIELD__image_asset.init_as_input_transform_none(
    { category: ENUM__image_asset_category.IMAGE },
    {
      graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE,
      field_role: ENUM__field_role.IMAGE__MAIN,
      store__interaction: ENUM__field_store_interaction.READ_AND_WRITE,
      store__family: ENUM__ml_asset_family.NONE,
      data__is_required: false,
    },
  )
  image!: FIELD__image_asset;

  @FIELD__image_asset.init_as_input_transform_none(
    { category: ENUM__image_asset_category.MASK },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE, field_role: '📐 Image Main Mask', ui__has_component: false },
  )
  image_mask!: FIELD__image_asset;

  @FIELD__image_crop_box.init_as_input(
    {},
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE, ui__has_component: false, data__is_required: false },
  )
  crop_box!: FIELD__image_crop_box;
  /*
   * META
   */

  /*
   * OUTPUT
   */

  /*
   * EVENTS
   */

  @FIELD__image_asset.init_as_output(
    { category: ENUM__image_asset_category.IMAGE },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE, field_role: '📐 Image Canvas Cropped' },
  )
  out__image_cropped!: FIELD__image_asset;

  @FIELD__image_asset.init_as_output(
    { category: ENUM__image_asset_category.MASK },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE, field_role: '📐 Image Mask Cropped' },
  )
  out__image_mask_cropped!: FIELD__image_asset;

  /*
   *
   */
  set_category(category: ENUM__image_asset_category) {
    let fields = [this.image, this.out__image_cropped];

    for (let field of fields) {
      field.category = category;
      field.image__clear();
    }
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.IMAGE__VIEWPORT);
  }

  post_init() {
    super.post_init();
  }

  prepare_for_usage_in(graph: DTO_GRAPH__instance) {
    let { grid2d_cell__aspect_ratio } = graph.invocation_grid2d_view;

    /*
     * TARGET ASPECT RATIO
     */

    if (this.crop_box.target_aspect_ratio != grid2d_cell__aspect_ratio) {
      this.crop_box.target_aspect_ratio = grid2d_cell__aspect_ratio;
    }

    /*
     *
     */

    let image_source = this.image.find_source(graph);

    if (!image_source.get_has_content()) {
      this.crop_box.crop_box__clear();
      return;
    }

    /*
     *
     */

    let image_size_original = image_source.get_image_size();

    if (this.crop_box.image_size_original.is_equal(image_size_original)) return;
    if (this.crop_box.image_size_original.is_stub() && image_size_original.is_stub()) return;

    this.crop_box.image_size_original = image_size_original.clone();
  }
  /*
   *
   */

  field_image__get_under_mask_for(field: FIELD__image_asset) {
    if (field.meta.field_id == this.image_mask.meta.field_id) return this.image;
    if (field.meta.field_id == this.out__image_mask_cropped.meta.field_id) return this.out__image_cropped;

    return FIELD__image_asset.CREATE_STUB();
  }

  field_image__get_mask_for(field: FIELD__image_asset) {
    if (field.meta.field_id == this.image.meta.field_id) return this.image_mask;
    if (field.meta.field_id == this.out__image_cropped.meta.field_id) return this.out__image_mask_cropped;

    return FIELD__image_asset.CREATE_STUB();
  }

  /*
   *
   */

  /*
   *
   */

  cropbox_maximize(graph: DTO_GRAPH__instance) {
    let field_new = this.crop_box.clone();
    field_new.crop_box__init();

    graph.field__replace(field_new);
  }
}
